
export const solutions = {
  '1gb.solutions': 'حلول 1Gb',
  '10gb.solutions': 'حلول 10Gb',
  '1gb.vpx.accessories': 'ملحقات VPX 1Gb',
  'software': 'البرمجيات',
  '1gb.description': 'حلول AV عبر IP عالية الأداء 1Gb',
  '10gb.description': 'حلول AV عبر IP فائقة الأداء 10Gb',
  'vpx.accessories.description': 'ملحقات أساسية لحلول VPX 1Gb',
  'software.description': 'برنامج Aurora IPBaseT Manager هو تطبيق تحكم شامل لمنتجات Aurora IPBaseT AV عبر IP من سلسلة IPX وVPX وVLX',
  'avoip.solutions': 'حلول AVOIP',
  'choose.network.speed': 'اختر سرعة الشبكة المفضلة لديك',
  'touch.controllers': 'وحدات تحكم باللمس',
  'touch.controllers.description': 'واجهات لوحة لمس احترافية للتحكم السلس',
  'control.processors': 'معالجات التحكم',
  'control.processors.description': 'معالجات تحكم متقدمة لإدارة النظام',
  'reax.software': 'البرمجيات',
  'reax.software.description': 'برمجيات تطوير نظام التحكم المهني',
  'reax.accessories': 'الملحقات',
  'reax.accessories.description': 'ملحقات أساسية لأنظمة ReAX',
  'reax.control.solutions': 'حلول تحكم ReAX',
  'choose.control.solution': 'اختر حل التحكم المفضل لديك',
  'digital.signal.processors': 'معالجات الإشارة الرقمية',
  'dsps.description': 'حلول معالجة الصوت المهنية',
  'amplifiers': 'مكبرات الصوت',
  'amplifiers.description': 'تضخيم صوتي عالي الأداء',
  'speakers': 'مكبرات صوت',
  'speakers.description': 'حلول إعادة إنتاج الصوت المتميزة',
  'audio.solutions': 'حلول الصوت',
  'choose.audio.solution': 'اختر حل الصوت المفضل لديك',
};
